import React from 'react'
import './Cart.css'
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import Footer from '../../../component/Footer/Footer';
import LayoutWrapper from '../../../component/LayoutWrapper/';
import { Link } from 'react-router-dom';
import {cartListView, doCartListRes} from '../../../action/CartListAction';
import { updateCart, doCartUpdateRes } from '../../../action/CartUpdateAction';
import { cartRemoveItem, doRemoveCartItemRes} from '../../../action/RemoveCartItemAction';
import emptyCart from '../../../assets/images/IlustrasiCart.png'

import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';

class Cart extends React.PureComponent {

    constructor() {
        super();
        this.state = {
            firstInput: '',
            secondInput: '',
            cartViewData: [],
            qty:1,
            cartCheck: false,
            updateCart: false,
            totalPrice: 0,
            sub_total: '',
            removeCart: false,
        }
        ReactGA.initialize('UA-64201999-5');
        ReactGA.pageview(window.location.pathname + window.location.search);

        ReactPixel.init('784849368913134');

        ReactPixel.pageView();
    }

    componentDidMount(){
        const cartData={
            user_id : localStorage.getItem('userId')            
        }
        this.props.cartListView(cartData)
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.doCartListRes && nextProps.doCartListRes.user){
            if(nextProps.doCartListRes.user && nextProps.doCartListRes.user.CartListViewRes){
                if(nextProps.doCartListRes.user.CartListViewRes && nextProps.doCartListRes.user.CartListViewRes.result === true){
                    
                    this.setState({
                        cartViewData : nextProps.doCartListRes.user.CartListViewRes.cart,
                        sub_total : nextProps.doCartListRes.user.CartListViewRes.sub_total
                        // cartCheck:false
                    })
                }
            }
        }

        if(nextProps.doCartUpdateRes && nextProps.doCartUpdateRes.user){
            if(nextProps.doCartUpdateRes.user && nextProps.doCartUpdateRes.user.CartUpdateRes){
                if(nextProps.doCartUpdateRes.user.CartUpdateRes && nextProps.doCartUpdateRes.user.CartUpdateRes.success === true && this.state.updateCart === true){
                    this.setState({
                        cartCheck:true,
                        updateCart:false
                    },()=>{
                        if(this.state.cartCheck){
                            const cartData={
                                user_id : localStorage.getItem('userId')                                
                            }                            
                            this.props.cartListView(cartData)
                        }
                    })
                }
            }
        }
        if(nextProps.doRemoveCartItemRes && nextProps.doRemoveCartItemRes.user){
            if(nextProps.doRemoveCartItemRes.user && nextProps.doRemoveCartItemRes.user.RemoveCartItemRes){
                if(nextProps.doRemoveCartItemRes.user.RemoveCartItemRes && nextProps.doRemoveCartItemRes.user.RemoveCartItemRes.results === true && this.state.removeCart=== true){
                    
                    
                    this.setState({
                        cartCheck:true,
                        removeCart:false
                    },()=>{
                        if(this.state.cartCheck){
                            const cartData={
                                user_id : localStorage.getItem('userId')                                
                            }                            
                            this.props.cartListView(cartData)
                        }
                    })
                }
            }
        }
    }

    decQty = (i) => {
        let data = this.state.cartViewData;
        if(data[i].qty > 1){
            data[i].qty--
            this.setState({
                cartViewData:[...data]
            })
            const decdata ={
                cart_id : data[i].id,
                qty: data[i].qty
            }
            this.setState({
                updateCart: true
            })
            this.props.updateCart(decdata)
        }
        
    }
    incQty = (i) => {
        let data = this.state.cartViewData;
        data[i].qty++
        this.setState({
            cartViewData:[...data]
        })
        const incdata ={
            cart_id : data[i].id,
            qty: data[i].qty
        }
        this.setState({
            updateCart: true
        })
        this.props.updateCart(incdata)
    }

    SubTotal=()=>{
        this.state.cartViewData && this.state.cartViewData.map((item)=>(
            this.setState({
                totalPrice: this.state.totalPrice + (item.price * item.qty)
            })
        ))
    }

    removetItemCart =(id)=>{
        const data = {
            cart_id : id
        }
        this.setState({
            removeCart: true
        })
        this.props.cartRemoveItem(data)
    }
   

    render() {
        return (        
            <div className="page-wrapper">
                <LayoutWrapper />
                <main className="main main-top">
                    <nav aria-label="breadcrumb" className="breadcrumb-nav mb-1">
                        <div className="container">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item active" aria-current="page">Shopping Cart</li>
                            </ol>
                        </div>
                        {/* End .container  */}
                    </nav>

                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8">
                                <div className="cart-table-container">
                                {this.state.cartViewData === null ?
                                            <div className="text-center">
                                                <img src={emptyCart} alt= "emptyCart" width={500} height={500} />
                                                <h4>Empty Cart</h4>
                                            </div>
                                                
                                            :
                                    <table className="table table-cart">
                                       
                                        <thead className="thead-rsp re-adjst">
                                            <tr className="re-adjust">
                                                <th className="product-col adjst-prodct re-adjust-product">Product</th>
                                                <th className="price-col">Price</th>
                                                <th className="qty-col">Qty</th>
                                                <th>Subtotal</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.cartViewData && this.state.cartViewData.map((item,i)=>(
                                                
                                                <tr className="product-row" key={i}>
                                                    <td className="product-col img-size1">
                                                        <figure className="product-image-container prodct-img">
                                                            {/* <a href="/" > */}
                                                                <img src={item.photo} className="product-image" alt="product"/>
                                                            {/* </a> */}
                                                        </figure>
                                                        <h2 className="product-title item-product-name">
                                                            {item.name}
                                                        </h2>
                                                    </td>
                                                    <td className="itm item-sign"><i className="fa fa-rupee-sign"></i> {item.price}.00</td>
                                                    <td>
                                                        <div className="product-single-qty btn-qty" style={{"display":"flex"}}>
                                                        
                                                            <button className="btn btn-outline qty-mns " disabled={item.qty === 1}  onClick={()=> this.decQty(i)}>-</button>

                                                            <input className="horizontal-quantity form-control qty-input" type="text" value={item.qty} readOnly/>
                                                            
                                                            <button className="btn btn-outline" onClick={()=> this.incQty(i)}>+</button>
                                                        </div>
                                                    </td>
                                                    <td><i className="fa fa-rupee-sign"></i>{item.price * item.qty}.00</td>
                                                    <td><i className="fa fa-trash-alt del-view-cart" onClick={() => this.removetItemCart(item.id)}></i></td>
                                                </tr>
                                            ))}                                                                    
                                        </tbody>                                       
                                    </table>}
                                    <table>
                                    <tfoot>
                                            <tr>
                                                <td colSpan="6" className="clearfix">
                                                    <div className="float-left">
                                                        <a href="/" className="btn btn-outline-secondary">Continue Shopping</a>
                                                    </div>
                                                    {/* End .float-left */}

                                                    {/* <div className="float-right">
                                                        <a href="/cart" className="btn btn-outline-secondary btn-clear-cart">Clear Shopping Cart</a>
                                                        <a href="/cart" className="btn btn-outline-secondary btn-update-cart">Update Shopping Cart</a>
                                                    </div> */}
                                                    {/* End .float-right */}
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                                {/* End .cart-table-container */}

                                <div className="cart-discount">
                                    {/* <h4>Apply Discount Code</h4>
                                    <form action="/"> */}
                                        {/* <div className="input-group">
                                            <input type="text" className="form-control form-control-sm" placeholder="Enter discount code" name="applyDiscount" onChange = {(e) => this.setState({applyDiscount: e.target.applyDiscount})} value = {this.state.applyDiscount} required/>
                                            <div className="input-group-append">
                                                <button className="btn btn-sm btn-primary" type="submit">Apply Discount</button>
                                            </div>
                                        </div> */}
                                        {/* End .input-group */}
                                    {/* </form> */}
                                </div>
                                {/* End .cart-discount */}
                            </div>
                            {/* End .col-lg-8 */}
                            <div className="col-lg-4">
                            {this.state.cartViewData !== null ?
                                <div className="cart-summary">
                                    <h3>CART TOTALS</h3>
                                    <table className="table table-totals">
                                        <tbody>
                                            <tr>
                                                <td>Subtotal</td>
                                                <td><i className="fa fa-rupee-sign"></i>{this.state.sub_total}.00</td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td>Order Total</td>
                                                
                                                <td><i className="fa fa-rupee-sign"></i> {this.state.sub_total}.00</td>
                                            </tr>
                                        </tfoot>
                                    </table>

                                    <div className="checkout-methods checkout-btn">
                                        <Link to="/checkoutshippingaddress" className="btn btn-block btn-sm btn-primary show-color">Go to Checkout</Link>
                                       
                                    </div>
                                     
                                </div> : ''}
                                
                            </div>
                             {/* End .col-lg-4 */}
                        </div>
                         {/* End .row  */}
                    </div>
                     {/* End .container  */}
                    <div className="mb-6"></div>
                     {/* margin */}
                </main>
                 {/* End .main */}
                <Footer />
        
            </div>
        )
                
                
    }
}

Cart.propTypes = {
    doCartListRes: PropTypes.any, 
    doCartUpdateRes: PropTypes.any,
    doRemoveCartItemRes: PropTypes.any
};

const mapStateToProps = createStructuredSelector({
    doCartListRes: doCartListRes,
    doCartUpdateRes: doCartUpdateRes,
    doRemoveCartItemRes: doRemoveCartItemRes,
});

function mapDispatchToProps(dispatch) {
    return {
        cartListView: (data) => dispatch(cartListView(data)),
        updateCart: (data) => dispatch(updateCart(data)),
        cartRemoveItem: (data) => dispatch(cartRemoveItem(data)),
    };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Cart)
